import React, { useEffect } from "react";
import { Card, Input, Button, Typography, Alert, Form } from "antd";

const { Title, Paragraph } = Typography;

const SecuritySetupForm = ({
  form,
  onContinue,
  formValues,
  onChangeFormValues,
}) => {
  // Sync form values from parent when switching steps
  useEffect(() => {
    form.setFieldsValue(formValues);
  }, [formValues, form]);

  const handleSubmit = (values) => {
    console.log("Security form submitted:", values);
    onContinue(values); // Pass values to parent after validation
  };

  return (
    <Card
      className="mt-4"
      style={{
        marginTop: 32,
        width: "100%",
        maxWidth: 400,
        maxHeight: "80vh", // Restrict height
        overflowY: "auto", // Enable vertical scrolling
      }}
      bodyStyle={{ padding: 24 }}
    >
      <div style={{ maxHeight: "70vh", overflowY: "auto", paddingRight: 8 }}>
        <Alert
          message="Account Created Successfully!"
          type="success"
          showIcon
          className="mb-3 text-center"
        />
        <Title level={4} className="text-center">
          Set Security Credentials
        </Title>
        <Paragraph className="text-center" type="secondary">
          Create your Transaction PIN and Login Password
        </Paragraph>

        <Form layout="vertical" form={form} onFinish={handleSubmit}>
          {/* Transaction PIN */}
          <Title level={4} style={{ fontSize: "14px", marginBottom: 0 }}>
            Transaction PIN
            <span
              style={{
                marginLeft: 8,
                backgroundColor: "#d2b0eb",
                padding: "2px 8px",
                borderRadius: 6,
                fontSize: "10px",
                fontWeight: 500,
                color: "#6200ad",
              }}
            >
              For USSD & Wallet
            </span>
          </Title>

          <Form.Item
            label="4-digit PIN"
            name="pinNo"
            rules={[
              { required: true, message: "Please enter your 4-digit PIN" },
              { len: 4, message: "PIN must be exactly 4 digits" },
            ]}
          >
            <Input.Password
              maxLength={4}
              type="number"
              style={{ textAlign: "center" }}
              placeholder="Enter 4-digit PIN"
              value={formValues.pinNo}
              onChange={(e) => onChangeFormValues("pinNo", e.target.value)}
            />
          </Form.Item>

          <Form.Item
            label="Confirm PIN"
            name="confirmPin"
            style={{ textAlign: "center" }}
            dependencies={["pinNo"]}
            rules={[
              { required: true, message: "Please confirm your PIN" },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue("pinNo") === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error("PINs do not match"));
                },
              }),
            ]}
          >
            <Input.Password
              maxLength={4}
              type="number"
              placeholder="Re-enter 4-digit PIN"
              value={formValues.confirmPin}
              onChange={(e) => onChangeFormValues("confirmPin", e.target.value)}
            />
          </Form.Item>

          {/* Login Password */}
          <Title level={4} style={{ fontSize: "14px", marginBottom: 0 }}>
            Login Password
            <span
              style={{
                marginLeft: 8,
                backgroundColor: "#cae4be",
                padding: "2px 8px",
                borderRadius: 6,
                fontSize: "10px",
                fontWeight: 500,
                color: "#4fd010",
              }}
            >
              For App & Web
            </span>
          </Title>

          <Form.Item
            label="Login Password"
            name="loginPassword"
            rules={[
              { required: true, message: "Please enter your password" },
              { min: 6, message: "Password must be at least 6 characters" },
            ]}
          >
            <Input.Password
              placeholder="Enter password"
              value={formValues.loginPassword}
              onChange={(e) =>
                onChangeFormValues("loginPassword", e.target.value)
              }
            />
          </Form.Item>

          <Form.Item
            label="Confirm Password"
            name="confirmPassword"
            dependencies={["loginPassword"]}
            rules={[
              { required: true, message: "Please confirm your password" },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue("loginPassword") === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error("Passwords do not match"));
                },
              }),
            ]}
          >
            <Input.Password
              placeholder="Re-enter password"
              value={formValues.confirmPassword}
              onChange={(e) =>
                onChangeFormValues("confirmPassword", e.target.value)
              }
            />
          </Form.Item>

          <Form.Item>
            <Button
              type="primary"
              size="large"
              block
              style={{
                backgroundColor: "#1d4ed8",
                borderColor: "#1d4ed8",
              }}
              htmlType="submit"
            >
              Set Security Credentials
            </Button>
          </Form.Item>

          <Paragraph
            type="secondary"
            className="text-center mt-3"
            style={{ fontSize: 12 }}
          >
            🔒 Your credentials are encrypted and secure. Keep your PIN and
            password safe and don't share them.
          </Paragraph>
        </Form>
      </div>
    </Card>
  );
};

export default SecuritySetupForm;
